import type { QueryClient, QueryKey } from "@tanstack/react-query";

export interface QueryScope {
  userId: string | null;
  organizationId: string | null;
}

export function scopedQueryKey(scope: QueryScope, key: readonly unknown[]): QueryKey {
  return ["scope", scope.userId ?? "anonymous", scope.organizationId ?? "none", ...key];
}

export function sameQueryScope(left: QueryScope, right: QueryScope): boolean {
  return left.userId === right.userId && left.organizationId === right.organizationId;
}

/** Remove cached data before another authenticated scope can render it. */
export async function clearPreviousQueryScope(queryClient: QueryClient): Promise<void> {
  await queryClient.cancelQueries();
  queryClient.removeQueries();
}
